import { useState } from "react";
import { Box, Typography } from "@mui/material";
import { ReceiptLongOutlined } from "@mui/icons-material";
import { format } from "date-fns";

import PageTitle from "../../../components/PageTitle";
import { DataTable, DataTableColumn, EmptyState, StatusBadge } from "../../../components/ui";
import { PlanHistoryRow, usePlanHistory } from "./use-plan-history";

// ----------------------------------------------------------------------

const PAGE_SIZE = 10;

const formatDate = (value?: Date) => (value ? format(new Date(value), "dd/MM/yyyy") : "—");

const columns: DataTableColumn<PlanHistoryRow>[] = [
  {
    key: "plan",
    header: "Plano",
    width: "1.4fr",
    render: (row) => (
      <Typography sx={{ fontSize: "13.5px", fontWeight: 600, color: "text.primary" }}>{row.planName || "—"}</Typography>
    ),
  },
  {
    key: "created",
    header: "Data do evento",
    width: "1fr",
    render: (row) => <Typography sx={{ fontSize: "13.5px", color: "text.secondary" }}>{formatDate(row.createdAt)}</Typography>,
  },
  {
    key: "end",
    header: "Fim do plano",
    width: "1fr",
    render: (row) => <Typography sx={{ fontSize: "13.5px", color: "text.secondary" }}>{formatDate(row.endDate)}</Typography>,
  },
  {
    key: "event",
    header: "Evento",
    width: "1.2fr",
    render: (row) => <StatusBadge status={row.statusLabel} tone={row.tone} />,
  },
];

export const HistoryPlan: React.FC = () => {
  const { rows, loading, error, reload } = usePlanHistory();
  const [page, setPage] = useState(1);

  const pageRows = rows.slice((page - 1) * PAGE_SIZE, page * PAGE_SIZE);

  const emptyState = error ? (
    <EmptyState title="Erro ao carregar" description={error} actionLabel="Tentar novamente" onAction={reload} />
  ) : (
    <EmptyState
      icon={<ReceiptLongOutlined />}
      title="Nenhum evento ainda"
      description="As atualizações da sua assinatura nos últimos 12 meses aparecerão aqui."
    />
  );

  return (
    <Box sx={{ width: "100%", p: { xs: "18px 16px 24px", md: 4 } }}>
      <PageTitle title="Histórico de planos" />

      <Typography sx={{ mb: 2.5, fontSize: "14px", color: "text.secondary" }}>
        Acompanhe as atualizações da sua assinatura nos <strong>últimos 12 meses</strong>.
      </Typography>

      <DataTable
        columns={columns}
        rows={pageRows}
        rowKey={(row) => row.id}
        loading={loading}
        emptyState={emptyState}
        page={page}
        pageSize={PAGE_SIZE}
        totalRows={rows.length}
        onPageChange={setPage}
        minWidth={640}
        countLabel={`${rows.length} ${rows.length === 1 ? "evento" : "eventos"}`}
      />
    </Box>
  );
};
